// extracted by mini-css-extract-plugin
export default {"SideBar":"SideBar_SideBar__vejd8","Menu":"SideBar_Menu__g3UV8"};